import Vue from 'vue';
import * as MUTATIONS from '@/store/constants/mutations.js';

export const mutations = {
    [MUTATIONS.LOAD_LANGUAGE](state, { language_name, language }) {
        if (!state.languages.hasOwnProperty(language_name)) {
            Vue.set(state.languages, language_name, language);
        }
        else {
            language.mergeWith(state.languages[language_name]);
            state.languages[language_name] = language;
        }
    },

    [MUTATIONS.ADD_LANGUAGE_FILE](state, file) {
        if (!state.loaded.includes(file)) {
            state.loaded.push(file);
        }
    },

    [MUTATIONS.SET_CURRENT_LANGUAGE](state, language) {
        Vue.set(state, 'current_language', language);
    },
};
